import { ContentType } from './ContentType';
export const DefaultContentTypeOrder = [
  ContentType.view,
  ContentType.metric,
  ContentType.workbook,
  ContentType.lens,
  ContentType.unifieddatasource,
  ContentType.virtualconnection,
  ContentType.collection,
  ContentType.project,
  ContentType.flow,
  ContentType.datarole,
  ContentType.table,
  ContentType.database,
  ContentType.predictivemodel,
];

export const DefaultContentTypeDropdownOrder = [
  ContentType.view,
  ContentType.metric,
  ContentType.workbook,
  ContentType.collection,
  'Separator',
  ContentType.unifieddatasource,
  ContentType.flow,
  ContentType.project,
  'Separator',
  ContentType.lens,
  ContentType.virtualconnection,
  ContentType.table,
  ContentType.database,
  ContentType.datarole,
  ContentType.predictivemodel,
];
